export enum DateFormats {
  MM_DD_YYYY = "MM/DD/YYYY",
  MM_DD_YYYY_h_mm_a = "MM/DD/YYYY h:mm a",
  MM_DD_YYYY_hh_mm_ss_a = "MM/DD/YYYY hh:mm:ss a",
  MM_DD_YYYY_comma_hh_mm_ss_a = "MM/DD/YYYY, hh:mm:ss a",
  TIME_AM_PM = "hh:mm a",
  YYYY_MM_DD = "YYYY-MM-DD",
  YYYYMMDD = "YYYYMMDD",
  TIME_HH_MM_SS = "hh:mm:ss",
}
export const ValidYear = 1900;
export const dateFormat = "0001-01-01T00:00:00";

const dateOfBirth = "dateOfBirth";
const startOfCareDate = "startOfCareDate";

export const FieldType = {
  startOfCareDate,
  dateOfBirth,
};

export const DateFieldType = {
  startOfCareDate,
  dateOfBirth,
};
